import SearchBoxMobile from 'views/components/organisms/SearchBox/SearchBoxMobile'

const SearchBoxContainerMobile = props => <SearchBoxMobile {...props} />

SearchBoxContainerMobile.propTypes = SearchBoxMobile.propTypes
SearchBoxContainerMobile.defaultProps = SearchBoxMobile.defaultProps

export default SearchBoxContainerMobile
